import { useParams } from "react-router-dom";
import { LockCheck } from "../components/userLocks/LockCheck";
import ViewQuote from "./ViewQuote";
import QuoteDataProvider from "../features/quotes/contexts/quoteDataProvider";

const ViewQuoteBootstrap = () => {
    const { opportunityId, quoteId, quoteRevisionId } = useParams();
    return (
        <>
            <LockCheck entity="QuoteRevision" entityId={quoteRevisionId} lockChildElements={false}>
                <QuoteDataProvider>
                    <ViewQuote opportunityId={opportunityId} quoteId={quoteId} quoteRevisionId={quoteRevisionId} />
                </QuoteDataProvider>
            </LockCheck>
        </>
    );
}

export default ViewQuoteBootstrap;
